import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ISTDateFormat } from "../../../../../utils/helper";

function ViewInterviewJoin() {
  const location = useLocation();
  const {
    id,
    type,
    event_type,
    STARTDATE,
    TITLE,
    STARTTIME,
    ENDTIME,
    BATCHNAME,
    TEAMSURL,
    CLASSMODE,
  } = location.state || {};

  const navigate = useNavigate();
  const navigateToPreviousScreen = () => {
    navigate(-1); // Navigate back by one step in the history
  };
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [fdata, setFdata] = useState({
    name: TITLE,
    start_date: moment(STARTDATE).format("DD/MM/YYYY"),
    batchName: BATCHNAME,
    start_time: STARTTIME,
    end_time: ENDTIME,
    teams_url: TEAMSURL,
    class_mode: CLASSMODE,
  });
  const isOnlineMode =
    fdata.class_mode && fdata.class_mode.toLowerCase() !== "classroom";
  const handleMeeting = () => {
    window.open(fdata.teams_url, "_blank");
  };
  useEffect(() => {
    const interval = setInterval(() => {
      // Step 1: Parse the date
      const dateFormat = fdata.start_date.includes("-")
        ? "YYYY-MM-DD"
        : "DD/MM/YYYY";
      const classDate = moment(fdata.start_date, dateFormat);

      // Step 2: Combine date and time
      const startDateTime = moment(
        `${classDate.format("YYYY-MM-DD")} ${fdata.start_time}`,
        "YYYY-MM-DD HH:mm:ss"
      );
      const endDateTime = moment(
        `${classDate.format("YYYY-MM-DD")} ${fdata.end_time}`,
        "YYYY-MM-DD HH:mm:ss"
      );

      // Step 3: Subtract 10 minutes from the start time
      const thirtyMinutesBeforeStart = moment(startDateTime).subtract(
        30,
        "minutes"
      );

      // Step 4: Compare with current time
      const now = moment();
      const updatedButtonDisabled =
        now.isBefore(thirtyMinutesBeforeStart) || now.isAfter(endDateTime);

      setIsButtonDisabled(updatedButtonDisabled);
    }, 1000);

    return () => clearInterval(interval);
  }, [fdata.start_date, fdata.start_time, fdata.end_time]);

  return (
    <>
      <div
        className={` BathHeader container-fluid  global_container p-0 BathDet`}
        style={{ marginTop: 0 }}
        id="ex2-content"
      >
        <div className={"tab-pane fade show active col-md-12"}>
          <div className="row align-items-center">
            <div className="col-md-12 d-flex justify-content-between align-items-center flex-wrap">
              {/* Left Side - Heading */}
              <div className="mb-2">
                <h2 className="TitleHeader mb-0">View Interview</h2>
              </div>

              {/* Right Side - Buttons */}
              <div className="d-flex flex-wrap gap-2">
                {/* Back Button */}
                <Link
                  to="javascript:void(0)"
                  onClick={navigateToPreviousScreen}
                  className="secondaryButton"
                >
                  Back
                </Link>
                {/* Join Class Button */}
                {isOnlineMode && (
                  <Link
                    to="javascript:void(0)"
                    onClick={(e) => {
                      if (isButtonDisabled || !fdata.teams_url) {
                        e.preventDefault();
                        return;
                      }
                      handleMeeting();
                    }}
                    className={`primaryButton ${
                      isButtonDisabled ? "disabledbtn" : ""
                    }`}
                    variant="primary"
                  >
                    Join 
                  </Link>
                )}
              </div>
            </div>
          </div>

          <fieldset className="mt-3">
            <legend className="w-auto">Event Details</legend>
            <div className="row mb-3">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Interview Name</p>
                      <p className="confirm_value my-1">
                        {fdata.name !== null ? fdata.name : "⎯"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Batch Name</p>
                      <p className="confirm_value my-1">
                        {fdata.batchName || "⎯"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Date</p>
                      <p className="confirm_value my-1">
                        {}

                        {fdata.start_date || "⎯"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0"> Start Time</p>
                      <p className="confirm_value my-1">
                        {fdata.start_time !== null
                          ? moment(fdata.start_time, "HH:mm:ss").format(
                              "h:mm A"
                            )
                          : "⎯"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">End Time</p>
                      <p className="confirm_value my-1">
                        {fdata.end_time !== null
                          ? moment(fdata.end_time, "HH:mm:ss").format("h:mm A")
                          : "⎯"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </>
  );
}

export default ViewInterviewJoin;
